import { Component, OnInit, ViewChild } from '@angular/core';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { environment } from '../../../../environments/environment';
import { PoPageDynamicTableActions, PoPageDynamicTableComponent, PoPageDynamicTableCustomAction, PoPageDynamicTableCustomTableAction, PoPageDynamicTableFilters } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-regras-cte',
  templateUrl: './regras-cte.component.html',
  styleUrls: ['./regras-cte.component.css'],
  standalone: false
})
export class RegrasCteComponent implements OnInit {

  @ViewChild('dynamicTable', { static: true }) dynamicTable!: PoPageDynamicTableComponent;

  isLoading: boolean = false;
  fields: Array<PoPageDynamicTableFilters> = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/xml/cte-regras`;

  readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/home' }, { label: 'Contabilidade' }, { label: 'Outros', link: '/contabil-outros' }, { label: 'Regras CTe' }]
  };

  readonly actions: PoPageDynamicTableActions = {

    new: '/regras-cte-edit/',
    edit: '/regras-cte-edit/:id',
    remove: true,


  };
  pageCustomActions: Array<PoPageDynamicTableCustomAction> = [
  {
    label: 'Atualizar',
    action: this.updateTable.bind(this),
    icon: 'an an-arrows-clockwise'
  }]

  constructor(private readonly schemaBuilderService: SchemaBuilderService,) {
    this.schemaBuilderService.getTableSchema("cteregras").subscribe((data) => {
      this.fields = data;
    });
  }

  ngOnInit() {
  }
  updateTable() {
    this.dynamicTable.updateDataTable();
  }

}
